export type ClipQuote = {
  time: string;
  speaker: string;
  text: string;
};

export type DanmakuItem = {
  id: number;
  user: string;
  text: string;
};

export type TranscriptLine = {
  time: string;
  speaker: string;
  text: string;
};

export type Clip = {
  id: string;
  title: string;
  host: string;
  categoryId: string;
  duration: string;
  views: number;
  comments: number;
  date: string;
  cover: string;
  summary: string;
  tags: string[];
  hot: number;
  quotes: ClipQuote[];
  danmaku: DanmakuItem[];
  transcript: TranscriptLine[];
};

export type Category = {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
};

export const categories: Category[] = [
  { id: "all", name: "全部片段", icon: "ri-live-line", desc: "按更新时间汇总全部爆料直播片段", count: 9 },
  { id: "ent", name: "娱乐八卦", icon: "ri-vip-crown-line", desc: "嘉宾互怼、后台花絮与临场澄清", count: 2 },
  { id: "commerce", name: "电商带货", icon: "ri-shopping-bag-3-line", desc: "砍价翻车、报价单被摔的带货名场面", count: 1 },
  { id: "game", name: "游戏开黑", icon: "ri-gamepad-line", desc: "五杀被抢、怒退直播间的高能瞬间", count: 1 },
  { id: "sports", name: "体育赛事", icon: "ri-basketball-line", desc: "绝杀被吹、解说失声的争议现场", count: 1 },
  { id: "finance", name: "财经现场", icon: "ri-line-chart-line", desc: "财报电话会断线、现场改口的瞬间", count: 1 },
  { id: "tech", name: "科技测评", icon: "ri-smartphone-line", desc: "新品直播首秀卡死与紧急救场", count: 1 },
  { id: "life", name: "生活分享", icon: "ri-restaurant-2-line", desc: "百人挑战掀桌、陪伴自习突发状况", count: 2 },
];

export const clips: Clip[] = [
  {
    id: "ecommerce-price-war",
    title: "直播间当场砍价翻车，主播怒摔报价单",
    host: "老谭带货间",
    categoryId: "commerce",
    duration: "08:24",
    views: 1426000,
    comments: 38200,
    date: "2026-09-09",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20poster%20illustration%20of%20a%20chaotic%20live%20commerce%20streaming%20desk%20with%20price%20tags%20flying%20and%20a%20microphone%2C%20warm%20cream%20background%2C%20vermillion%20orange%20and%20golden%20amber%20palette%2C%20dramatic%20spotlight%2C%20grainy%20texture%2C%20modern%20Chinese%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=500&seq=bolo-cover-01&orientation=landscape",
    summary:
      "一场原本按脚本走的家电专场，因为供应商临时改价，主播与品牌方在镜头前你来我往了整整八分钟。报价单被摔在桌面的那一刻，弹幕彻底沸腾。",
    tags: ["砍价翻车", "现场改价", "带货名场面"],
    hot: 98,
    quotes: [
      { time: "01:12", speaker: "老谭", text: "这个价格我谈不下来，我谈不下来我就把这单退了，你们信不信？" },
      { time: "04:37", speaker: "品牌方", text: "系统就是显示这个价，我这边也没办法再往下压了。" },
      { time: "07:58", speaker: "老谭", text: "行，那就按你们说的来，今天的补贴我自己貼，观众别走。" },
    ],
    danmaku: [
      { id: 1, user: "爱看热闹的柚子", text: "这报价单摔得也太响了" },
      { id: 2, user: "囤货小分队", text: "链接呢链接呢我等了五分钟了" },
      { id: 3, user: "理性消费者", text: "其实这个价已经比平时低了" },
      { id: 4, user: "打工人阿凯", text: "主播这波是真情实感了" },
      { id: 5, user: "夜猫子选手", text: "品牌方脸色我隔着屏幕都看见了" },
    ],
    transcript: [
      { time: "00:00", speaker: "老谭", text: "来，家人们，今天这场是家电专场，我先说好，价格是我自己一场一场谈下来的。" },
      { time: "01:12", speaker: "老谭", text: "这个价格我谈不下来，我谈不下来我就把这单退了，你们信不信？" },
      { time: "03:05", speaker: "品牌方", text: "我们内部审批是有流程的，不是说改就能改。" },
      { time: "04:37", speaker: "品牌方", text: "系统就是显示这个价，我这边也没办法再往下压了。" },
      { time: "06:20", speaker: "老谭", text: "先别刷屏，让我把话说完，这个款我压了三天。" },
      { time: "07:58", speaker: "老谭", text: "行，那就按你们说的来，今天的补贴我自己貼，观众别走。" },
    ],
  },
  {
    id: "game-rage-quit",
    title: "五杀被抢怒退直播间，队友连麦道歉名场面",
    host: "阿野开黑",
    categoryId: "game",
    duration: "06:41",
    views: 986000,
    comments: 26400,
    date: "2026-09-08",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20poster%20illustration%20of%20a%20glowing%20gaming%20setup%20with%20neon%20controllers%20and%20a%20dark%20monitor%20wall%2C%20warm%20cream%20background%20with%20vermillion%20orange%20and%20golden%20amber%20accents%2C%20dramatic%20rim%20lighting%2C%20grainy%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=500&seq=bolo-cover-02&orientation=landscape",
    summary:
      "决胜局只剩最后一枪，队友抢下五杀。主播当场沉默，随后退出直播间。十分钟后队友开麦道歉，两人又笑着打完了加时赛。",
    tags: ["五杀被抢", "怒退直播间", "队友道歉"],
    hot: 93,
    quotes: [
      { time: "02:18", speaker: "阿野", text: "这一枪我打了四十分钟，你告诉我你顺手就补了？" },
      { time: "03:02", speaker: "阿野", text: "下播，我今天不打了，别劝。" },
      { time: "08:55", speaker: "队友小满", text: "是我抢的，对不起，下次我一定让你收线。" },
    ],
    danmaku: [
      { id: 1, user: "上分靠缘分", text: "这个补刀确实有点离谱" },
      { id: 2, user: "老观众了", text: "退直播间那一下我笑出声" },
      { id: 3, user: "凌晨三点局", text: "等他回来等了十分钟" },
      { id: 4, user: "云顶小王子", text: "道歉这段太真诚了" },
      { id: 5, user: "键盘侠退休", text: "队友是真的懂他" },
    ],
    transcript: [
      { time: "00:00", speaker: "阿野", text: "最后一局，赢了今天就到星耀一，我说的。" },
      { time: "02:18", speaker: "阿野", text: "这一枪我打了四十分钟，你告诉我你顺手就补了？" },
      { time: "03:02", speaker: "阿野", text: "下播，我今天不打了，别劝。" },
      { time: "03:20", speaker: "弹幕", text: "直播间画面切到了待机界面，观众数停在四万二。" },
      { time: "08:55", speaker: "队友小满", text: "是我抢的，对不起，下次我一定让你收线。" },
    ],
  },
  {
    id: "entertainment-guest-clash",
    title: "两位嘉宾直播互怼十分钟，导演紧急切广告",
    host: "周五夜谈",
    categoryId: "ent",
    duration: "11:06",
    views: 2135000,
    comments: 51900,
    date: "2026-09-07",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20poster%20illustration%20of%20two%20empty%20interview%20stools%20facing%20each%20other%20with%20microphones%20and%20shattered%20glass%20shapes%2C%20warm%20cream%20background%2C%20vermillion%20orange%20and%20amber%20palette%2C%20dramatic%20spotlight%2C%20grainy%20texture%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=500&seq=bolo-cover-03&orientation=landscape",
    summary:
      "一档对谈节目在聊到行业规则时突然失控，两位嘉宾从观点分歧聊成了当面质疑。场面僵持十分钟后，导演切进广告。",
    tags: ["嘉宾互怼", "现场失控", "导演切广告"],
    hot: 99,
    quotes: [
      { time: "02:45", speaker: "嘉宾A", text: "你说的那套逻辑，在真实的剧组里根本跑不通。" },
      { time: "05:10", speaker: "嘉宾B", text: "我尊重你的经验，但我更相信数据。" },
      { time: "10:48", speaker: "主持人", text: "我们先休息一下，广告之后继续聊这个话题。" },
    ],
    danmaku: [
      { id: 1, user: "追更不睡觉", text: "这比正片好看多了" },
      { id: 2, user: "吃瓜第一线", text: "切广告那一刻我笑喷" },
      { id: 3, user: "冷静观察员", text: "其实两边说的都有道理" },
      { id: 4, user: "沙发常驻嘉宾", text: "主持人控场能力是真强" },
      { id: 5, user: "深夜档观众", text: "求广告回来后完整版" },
    ],
    transcript: [
      { time: "00:00", speaker: "主持人", text: "今天两位都带着作品来，我们先聊点行业里不太有人愿意说的。" },
      { time: "02:45", speaker: "嘉宾A", text: "你说的那套逻辑，在真实的剧组里根本跑不通。" },
      { time: "05:10", speaker: "嘉宾B", text: "我尊重你的经验，但我更相信数据。" },
      { time: "08:30", speaker: "嘉宾A", text: "数据也可以被选择性使用，你比我清楚。" },
      { time: "10:48", speaker: "主持人", text: "我们先休息一下，广告之后继续聊这个话题。" },
    ],
  },
  {
    id: "sports-overtime-call",
    title: "加时绝杀被吹无效，解说当场失声八秒",
    host: "赛场直击",
    categoryId: "sports",
    duration: "05:32",
    views: 1764000,
    comments: 44700,
    date: "2026-09-06",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20poster%20illustration%20of%20a%20basketball%20arena%20scoreboard%20glowing%20in%20dramatic%20darkness%20with%20motion%20streaks%2C%20warm%20cream%20and%20vermillion%20orange%20and%20amber%20palette%2C%20cinematic%20lighting%2C%20grainy%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=500&seq=bolo-cover-04&orientation=landscape",
    summary:
      "加时赛最后 1.8 秒，客队完成绝杀，全场欢呼还没落，裁判回看后判定超时无效。解说沉默了整整八秒才接上话。",
    tags: ["绝杀被吹", "裁判回看", "解说失声"],
    hot: 95,
    quotes: [
      { time: "01:05", speaker: "解说", text: "球进了！这球进了！全场都站起来了！" },
      { time: "02:40", speaker: "解说", text: "等一下，裁判示意要回看最后这个回合。" },
      { time: "04:12", speaker: "解说", text: "……无效。这球，判无效。" },
    ],
    danmaku: [
      { id: 1, user: "看球二十年", text: "这慢镜头是真的压线了" },
      { id: 2, user: "主场气氛组", text: "全场瞬间安静我鸡皮疙瘩都起来了" },
      { id: 3, user: "战术板爱好者", text: "其实前面那个暂停才是关键" },
      { id: 4, user: "凌晨看球", text: "解说那八秒是真的说不出话" },
      { id: 5, user: "客队球迷", text: "愿赌服输 等下一场" },
    ],
    transcript: [
      { time: "00:00", speaker: "解说", text: "加时赛最后一攻，客队没有暂停了，只能自己打。" },
      { time: "01:05", speaker: "解说", text: "球进了！这球进了！全场都站起来了！" },
      { time: "02:40", speaker: "解说", text: "等一下，裁判示意要回看最后这个回合。" },
      { time: "04:12", speaker: "解说", text: "……无效。这球，判无效。" },
      { time: "05:00", speaker: "解说", text: "比分定格，主队逃过一劫，系列赛回到同一起跑线。" },
    ],
  },
  {
    id: "finance-earnings-line",
    title: "财报电话会突然断线，CEO现场改口供",
    host: "资本夜话",
    categoryId: "finance",
    duration: "09:14",
    views: 743000,
    comments: 16800,
    date: "2026-09-05",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20poster%20illustration%20of%20a%20corporate%20earnings%20press%20podium%20with%20falling%20chart%20lines%20and%20a%20phone%20receiver%2C%20warm%20cream%20background%2C%20vermillion%20orange%20and%20amber%20palette%2C%20dramatic%20spotlight%2C%20grainy%20texture%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=500&seq=bolo-cover-05&orientation=landscape",
    summary:
      "一场季度财报电话会进行到问答环节时突然中断。重新连上线后，CEO 对同一个问题的回答出现了明显变化，参会分析师当场追问。",
    tags: ["财报电话会", "突然断线", "口径变化"],
    hot: 87,
    quotes: [
      { time: "03:26", speaker: "CEO", text: "我们对下一季度的预期保持不变，这一点没有悬念。" },
      { time: "06:02", speaker: "CEO", text: "刚才的信号不太好，我重新说一下我们对预期的看法。" },
      { time: "07:40", speaker: "分析师", text: "所以是下调还是持平？这个问题我想听一个明确答案。" },
    ],
    danmaku: [
      { id: 1, user: "持仓过山车", text: "这断线断得很微妙啊" },
      { id: 2, user: "看财报的下班人", text: "口径变化这条要记下来" },
      { id: 3, user: "价值派老陈", text: "分析师问得很到位" },
      { id: 4, user: "只买指数", text: "这段文字版我逐字看了三遍" },
      { id: 5, user: "深夜盯盘", text: "希望明天别太难看" },
    ],
    transcript: [
      { time: "00:00", speaker: "主持人", text: "欢迎参加本季度财报电话会议，接下来进入分析师问答环节。" },
      { time: "03:26", speaker: "CEO", text: "我们对下一季度的预期保持不变，这一点没有悬念。" },
      { time: "04:10", speaker: "主持人", text: "抱歉，会议连线出现了一点技术问题，我们稍后恢复。" },
      { time: "06:02", speaker: "CEO", text: "刚才的信号不太好，我重新说一下我们对预期的看法。" },
      { time: "07:40", speaker: "分析师", text: "所以是下调还是持平？这个问题我想听一个明确答案。" },
    ],
  },
  {
    id: "tech-launch-freeze",
    title: "新机直播首秀卡死，工程师后台紧急救场",
    host: "数码实测局",
    categoryId: "tech",
    duration: "07:18",
    views: 612000,
    comments: 12900,
    date: "2026-09-04",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20poster%20illustration%20of%20a%20smartphone%20launch%20stage%20with%20frozen%20glitch%20screens%20and%20tools%2C%20warm%20cream%20background%2C%20vermillion%20orange%20and%20amber%20palette%2C%20dramatic%20spotlight%2C%20grainy%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=500&seq=bolo-cover-06&orientation=landscape",
    summary:
      "万众期待的新机在直播演示相机功能时画面直接冻结，主播现场重启两次无果。后台工程师接手后，用备用机完成了整场演示。",
    tags: ["新品首秀", "画面卡死", "紧急救场"],
    hot: 84,
    quotes: [
      { time: "02:50", speaker: "主播", text: "大家稍等一下，这个界面好像卡住了，我们重启一次。" },
      { time: "05:20", speaker: "工程师", text: "我换一台备用机，参数完全一样，我们继续。" },
      { time: "06:55", speaker: "主播", text: "看得出来今天有点小意外，但该测的我一个都不落。" },
    ],
    danmaku: [
      { id: 1, user: "等等党永不为奴", text: "首秀就卡死 这运气也是没谁了" },
      { id: 2, user: "数码老白", text: "备用机救场挺专业的" },
      { id: 3, user: "手滑测评", text: "其实直播环境本来就容易出问题" },
      { id: 4, user: "攒钱换机", text: "想看的样张终于还是测到了" },
      { id: 5, user: "参数党路过", text: "主播这心态可以" },
    ],
    transcript: [
      { time: "00:00", speaker: "主播", text: "今天这台机器我等了两个月，第一件事就测夜景。" },
      { time: "02:50", speaker: "主播", text: "大家稍等一下，这个界面好像卡住了，我们重启一次。" },
      { time: "04:05", speaker: "主播", text: "第二次重启好像也没有反应，后台的同事在吗？" },
      { time: "05:20", speaker: "工程师", text: "我换一台备用机，参数完全一样，我们继续。" },
      { time: "06:55", speaker: "主播", text: "看得出来今天有点小意外，但该测的我一个都不落。" },
    ],
  },
  {
    id: "life-hotpot-spill",
    title: "百人火锅挑战现场掀桌，弹幕刷屏叫停",
    host: "深夜食堂屋",
    categoryId: "life",
    duration: "10:02",
    views: 1289000,
    comments: 33500,
    date: "2026-09-03",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20poster%20illustration%20of%20an%20overflowing%20hotpot%20table%20scene%20with%20steam%20and%20scattered%20bowls%2C%20warm%20cream%20background%2C%20vermillion%20orange%20and%20amber%20palette%2C%20dramatic%20overhead%20light%2C%20grainy%20texture%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=500&seq=bolo-cover-07&orientation=landscape",
    summary:
      "一场号称百人同吃的火锅挑战，进行到第四十分钟时桌面被挤翻，滚烫汤底洒了一地。弹幕齐刷刷刷起「停一下」，主播随即中止了挑战。",
    tags: ["火锅挑战", "现场掀桌", "弹幕叫停"],
    hot: 89,
    quotes: [
      { time: "02:10", speaker: "主播", text: "今天我们就一个目标，把这一百人份吃完，别劝我。" },
      { time: "06:44", speaker: "主播", text: "等一下，别挤了，桌子在晃！" },
      { time: "08:30", speaker: "主播", text: "今天的挑战到此结束，安全第一，我说停就停。" },
    ],
    danmaku: [
      { id: 1, user: "深夜饿肚子", text: "看着就烫 太危险了" },
      { id: 2, user: "火锅成精", text: "停一下停一下 别挤了" },
      { id: 3, user: "弹幕叫停团", text: "主播听劝这点好" },
      { id: 4, user: "厨房观察员", text: "这种挑战真的别硬来" },
      { id: 5, user: "吃播常客", text: "平安就好 下次换个玩法" },
    ],
    transcript: [
      { time: "00:00", speaker: "主播", text: "今天我们就一个目标，把这一百人份吃完，别劝我。" },
      { time: "02:10", speaker: "主播", text: "先给你们看看今天的锅底，三种口味一起上。" },
      { time: "06:44", speaker: "主播", text: "等一下，别挤了，桌子在晃！" },
      { time: "07:15", speaker: "主播", text: "没事没事，我人没事，地上有点滑，大家退后一点。" },
      { time: "08:30", speaker: "主播", text: "今天的挑战到此结束，安全第一，我说停就停。" },
    ],
  },
  {
    id: "music-live-crack",
    title: "高音破音瞬间被剪进鬼畜，歌手本尊回应",
    host: "现场收音机",
    categoryId: "ent",
    duration: "04:48",
    views: 1587000,
    comments: 40200,
    date: "2026-09-02",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20poster%20illustration%20of%20a%20concert%20stage%20microphone%20with%20sound%20wave%20rings%20spreading%20out%2C%20warm%20cream%20background%2C%20vermillion%20orange%20and%20amber%20palette%2C%20dramatic%20spotlight%2C%20grainy%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=500&seq=bolo-cover-08&orientation=landscape",
    summary:
      "一段现场 Live 的高音片段在开播后当晚就被剪成鬼畜，播放量在两个小时内破百万。第二天，歌手在直播里正面回应了这件事。",
    tags: ["现场破音", "鬼畜剪辑", "本尊回应"],
    hot: 92,
    quotes: [
      { time: "00:58", speaker: "歌手", text: "那个音本来就很难，我那天还感冒了，实话实说。" },
      { time: "02:22", speaker: "歌手", text: "剪得挺好的，比我唱得还好笑，我认了。" },
      { time: "03:50", speaker: "歌手", text: "下一场我把它唱回来，你们等着。" },
    ],
    danmaku: [
      { id: 1, user: "鬼畜区常驻", text: "这剪辑速度是真的快" },
      { id: 2, user: "听歌不挑", text: "本人回应也太可爱了" },
      { id: 3, user: "现场控", text: "感冒状态确实难顶" },
      { id: 4, user: "循环播放机", text: "等一个唱回来的版本" },
      { id: 5, user: "乐迷小林", text: "大气 这才是专业歌手" },
    ],
    transcript: [
      { time: "00:00", speaker: "歌手", text: "昨天那场大家都看了吧，我知道你们要说哪一句。" },
      { time: "00:58", speaker: "歌手", text: "那个音本来就很难，我那天还感冒了，实话实说。" },
      { time: "02:22", speaker: "歌手", text: "剪得挺好的，比我唱得还好笑，我认了。" },
      { time: "03:50", speaker: "歌手", text: "下一场我把它唱回来，你们等着。" },
    ],
  },
  {
    id: "life-study-confession",
    title: "连麦自习室突然表白，全场安静三十秒",
    host: "晚安自习室",
    categoryId: "life",
    duration: "05:56",
    views: 934000,
    comments: 28700,
    date: "2026-09-01",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20poster%20illustration%20of%20a%20quiet%20late%20night%20study%20room%20desk%20with%20desk%20lamp%20and%20open%20books%2C%20warm%20cream%20background%2C%20vermillion%20orange%20and%20amber%20palette%2C%20soft%20dramatic%20light%2C%20grainy%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=500&seq=bolo-cover-09&orientation=landscape",
    summary:
      "本来只是普通的连麦自习直播，一位常驻观众在休息时段突然开口表白。直播间安静了整整三十秒，随后弹幕铺满了屏幕。",
    tags: ["连麦自习", "突然表白", "全场安静"],
    hot: 81,
    quotes: [
      { time: "01:40", speaker: "观众", text: "我跟着这个自习室备考了三百多天，今天想跟你说句话。" },
      { time: "02:15", speaker: "主播", text: "……你先说，我在听。" },
      { time: "04:38", speaker: "主播", text: "谢谢你，真的，我们一起把最后这段路走完。" },
    ],
    danmaku: [
      { id: 1, user: "备考第200天", text: "这三十秒我屏住呼吸了" },
      { id: 2, user: "夜读的人", text: "自习室也能有这种名场面" },
      { id: 3, user: "上岸预备役", text: "主播的回应太温柔了" },
      { id: 4, user: "凌晨一点半", text: "弹幕突然全变成祝福" },
      { id: 5, user: "陪读三年", text: "祝你们都上岸" },
    ],
    transcript: [
      { time: "00:00", speaker: "主播", text: "晚上好，今天还是老规矩，五十分钟一个番茄钟。" },
      { time: "01:40", speaker: "观众", text: "我跟着这个自习室备考了三百多天，今天想跟你说句话。" },
      { time: "02:15", speaker: "主播", text: "……你先说，我在听。" },
      { time: "03:00", speaker: "观众", text: "不管结果怎么样，谢谢你每晚都在。" },
      { time: "04:38", speaker: "主播", text: "谢谢你，真的，我们一起把最后这段路走完。" },
    ],
  },
];

export type FaqItem = {
  question: string;
  answer: string;
};

export const faqs: FaqItem[] = [
  {
    question: "爆料现场的片段是从哪里整理的？",
    answer:
      "我们按照公开直播的录播内容，逐条挑出讨论度高、信息量大的片段，再做时间轴标记与文字转写。所有片段只做整理与索引，方便错过直播的人快速回看。",
  },
  {
    question: "主播关键发言和直播内容文字版有什么区别？",
    answer:
      "主播关键发言是从整场直播里挑出的核心表达，通常带时间点，适合快速抓住重点；直播内容文字版则是按时间顺序还原的完整上下文，适合想逐句核对的读者。",
  },
  {
    question: "弹幕热议是怎么筛选出来的？",
    answer:
      "弹幕热议来自片段对应时间段内出现频率最高、互动最集中的弹幕内容，我们会去掉重复与无意义刷屏，保留能反映现场气氛的部分。",
  },
  {
    question: "多久更新一次爆料片段？",
    answer:
      "热门场次通常在直播结束后的当晚完成整理，普通场次会在 24 小时内归档。首页的今日高能榜会优先展示当天讨论度上升最快的片段。",
  },
  {
    question: "可以提交自己发现的爆料片段吗？",
    answer:
      "可以。把你看到的场次、大致时间点和内容说明发到我们的联系邮箱，编辑会核对公开录播后决定是否收录，并在片段页标注来源场次。",
  },
];